import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import { IAnalystNotesApi, IAnalystNote } from '@/api/analystNotes/analystNotes.types';

export class AnalystNotesApi implements IAnalystNotesApi {
  private getBaseUrl(): string {
    return ApiEndpoints.ANALYST_NOTES;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getActiveAnalystNotes() {
    return this.httpClient.get<IAnalystNote[]>(`${this.getBaseUrl()}active`);
  }

  getAnalystNotesByAgioId(agioId: string) {
    return this.httpClient.get<IAnalystNote[]>(`${this.getBaseUrl()}get_by_agio_id/${agioId}/`);
  }
}
